"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importStar(require("react"));
const react_csv_1 = require("react-csv");
const ActionButtons_1 = __importDefault(require("coact/pages/modules/pageAction/ActionButtons"));
const react_hooks_1 = require("@apollo/react-hooks");
const apollo_boost_1 = require("apollo-boost");
const GET_WAREHOUSE = apollo_boost_1.gql `
    query ($warehouseId: String) {
      getWarehouse(id: $warehouseId) {
        name
      }
    }
`;
function DownloadingView({ datastore }) {
    const { loading: loadingStockInfos, error: stockInfosError, data: stockInfosData, } = datastore.query(1, 50000);
    const { loading: loadingWarehouseName, error: warehouseError, data: warehouseData, } = react_hooks_1.useQuery(GET_WAREHOUSE, { variables: { warehouseId: datastore.warehouseId } });
    if (stockInfosError)
        return react_1.default.createElement(react_1.default.Fragment, null, "stockInfosError");
    if (warehouseError)
        return react_1.default.createElement(react_1.default.Fragment, null, "warehouseError");
    if (loadingStockInfos || stockInfosData === undefined)
        return react_1.default.createElement(react_1.default.Fragment, null, "\u6B63\u5728\u6E96\u5099\u8981\u4E0B\u8F09\u7684\u8CC7\u6599");
    if (loadingWarehouseName || warehouseData === undefined)
        return react_1.default.createElement(react_1.default.Fragment, null, "\u6B63\u5728\u6E96\u5099\u8981\u4E0B\u8F09\u7684\u8CC7\u6599");
    const costs = datastore.hasCost ? [
        { label: '單位成本', key: 'averageCost' },
        { label: '庫存成本', key: 'totalCost' },
        { label: '管理中心成本', key: 'stock.product.centerCost' },
        { label: '門市成本', key: 'stock.product.storeCost' },
    ] : [];
    const headers = [
        { label: '商品條碼', key: 'stock.product.key' },
        { label: '商品名稱', key: 'stock.product.name' },
        { label: '庫存數量', key: 'qty' },
        ...costs,
        { label: '類別', key: 'stock.product.type' },
        { label: '品牌', key: 'stock.product.brand.name' },
        { label: '供應商', key: 'stock.product.supplier.name' },
    ];
    const warehouseName = warehouseData.getWarehouse.name;
    // noinspection SpellCheckingInspection
    const filename = `ctopt-${warehouseName}-${datastore.year}-${datastore.month.toString().padStart(2, '0')}.csv`;
    return (react_1.default.createElement(react_csv_1.CSVLink, { data: datastore.parse(stockInfosData), filename: filename, headers: headers },
        "\u4E0B\u8F09 ",
        filename));
}
function StockInfosDownloaderView({ datastore }) {
    const [isPreparing, setToPrepare] = react_1.useState(false);
    const actions = [
        {
            text: '下載 CSV',
            onClick: () => __awaiter(this, void 0, void 0, function* () {
                setToPrepare(true);
            }),
            props: {
                variant: 'outlined',
            },
        },
    ];
    const view = (() => {
        if (!isPreparing) {
            return (react_1.default.createElement(ActionButtons_1.default, { actions: actions, classes: null }));
        }
        return react_1.default.createElement(DownloadingView, { datastore: datastore });
    })();
    return (react_1.default.createElement("div", { style: {
            margin: '0px 30px',
            display: 'inline-block',
        } }, view));
}
exports.default = StockInfosDownloaderView;
